<div class="bg-white rounded-lg overflow-hidden flex flex-col">
  <div class="flex items-center p-4 border-b border-gray-200 select-none">
    <h3 class="text-lg font-medium">
      Spraakberichten
      <span class="text-gray-500">({{ totalQuestions() }}/{{ maxLength() }})</span>
    </h3>

    <div class="ml-auto min-h-10">
      <button
        mat-icon-button
        class="inline-flex!"
        matTooltip="Spraakbericht verwijderen"
        [disabled]="!selectedQuestionId() || disableControls()"
        (click)="handleQuestionDelete()"
      >
        <mat-icon>delete</mat-icon>
      </button>
      <button
        mat-icon-button
        class="inline-flex!"
        matTooltip="Spraakbericht bewerken"
        [disabled]="!selectedQuestionId() || disableControls()"
        (click)="handleQuestionEdit()"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        mat-icon-button
        class="inline-flex!"
        matTooltip="Spraakbericht toevoegen"
        [disabled]="!canAddQuestion() || disableControls()"
        (click)="handleQuestionAdd()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col gap-3 overflow-hidden">
    <div
      class="h-full overflow-x-hidden overflow-y-auto scrollbar-width-thin [scrollbar-gutter:stable]"
      cdkDropList
      [cdkDropListData]="nodes()"
      [cdkDropListDisabled]="disableControls()"
      (cdkDropListDropped)="handleQuestionDropped($event)"
    >
      @for (question of nodes(); track $index) {
        <app-question-list-item
          [data]="question"
          [draggable]="!disableControls()"
          [index]="$index + 1"
          [selected]="selectedQuestionId() === question._id"
          (selectionChange)="selectQuestion(question)"
        />
      } @empty {
        <div class="p-4 text-sm text-gray-500">Je hebt nog geen spraakberichten.</div>
      }
    </div>
  </div>
</div>
